import {Container, Loader} from "../core/components";
import React, {useMemo, useState} from "react";
import {maxiGet} from "../core/maxios";
import Status from "../core/status";
import {DateInput, MyReactTable, TextfieldInput} from "../core/input_fields";
import {Link} from "react-router-dom";
import {dateFormatTime} from "../core/dateFuncs";
import {PersonEditWrapper} from "../user/personHelpers";
import {FormContextWrapper} from "../core/form_context";
import {encodeGetParams} from "../core/helpers";

export function ExamstartList({match}) {
    const exam_ID = match?.params?.exam_ID;
    const [examstarts, setExamstarts] = useState()
    const [state,setState]=useState({start: new Date(new Date().getTime()-86400*30*1000).toISOString().slice(0, 10), end: new Date().toISOString().slice(0, 10)})

    const [{error, loading}, setStatusVar] = useState({})
    const loadExamstarts = () => maxiGet(`/exam/${exam_ID ? exam_ID + "/" : ""}examstarts?`+encodeGetParams(state), {setStatusVar}).then(setExamstarts)
    useMemo(loadExamstarts, [state.start, state.end]);


    return <Container name={"Antritte"} addName={<> ({examstarts?.length})</>}>
        <FormContextWrapper value={{state,setState}}>
            von <DateInput tag={"start"}/> bis &nbsp;<DateInput tag={"end"}/> <Loader loading={loading}/>
        </FormContextWrapper>
<br/>
        <Status text={error} type={"error"}/>

        <MyReactTable
            data={examstarts}
            defaultSorted={
                [
                    {id: "examstart.timeCreated", desc: true},

                ]
            }
            columns={[
                {
                    Header: "Zeitpunkt",
                    accessor: "examstart.timeCreated",
                    Cell: ({original, value}) => !exam_ID ? dateFormatTime(value) : <Link to={`/prüfungsantritt/${original.examstart.ID}/0`}>{dateFormatTime(value)}</Link>,
                },
                {
                    Header: "Person",
                    accessor: "person.fullname",
                    show: !!exam_ID,
                    filterable: true,
                    Cell: ({original, value}) => <PersonEditWrapper personLight={original.person}><em>{value}</em></PersonEditWrapper>
                },
                {
                    Header: "Vereine",
                    accessor: "person.clubs",
                    filterable: true,
                },
                {
                    Header: "Bestanden",
                    id: "passed",
                    accessor: row =>  (row.examstart.matrix ? "Prüfer" : (row.examstart?.passed ? "ja" : (row.examstart.timeLastModified === null ? "nicht angetreten" : "nein"))),
                    filterable: true,
                    maxWidth: 120,
                    Cell: ({original, value})=>original.examstart.passed !=null && value,
                },
                {
                    Header: "Punkteanzahl",
                    accessor: "examstart.score",
                    filterable: true,
                    maxWidth: 120,
                },
                {
                    Header: "Resultat",
                    accessor: "examstart.ID",
                    maxWidth: 120,
                    Cell: ({value, original}) => original.examstart.passed !=null &&<Link to={`/prüfungsantritt/${value}/resultat${original.examstart.matrix ? "Alle" : ""}`}>anzeigen</Link>
                },

            ]}
        />


    </Container>
}